<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8 6.39998V3L7.55 7.25001L11.8 11.5V8.1C14.6178 8.1 16.9 10.3822 16.9 13.2C16.9 16.0177 14.6178 18.3 11.8 18.3C8.98226 18.3 6.70001 16.0177 6.70001 13.2H5C5 16.957 8.04298 20 11.8 20C15.557 20 18.6 16.957 18.6 13.2C18.6 9.44301 15.557 6.39998 11.8 6.39998Z"
      fill="currentColor"
    />
  </svg>
</template>
